import { render, staticRenderFns } from "./Tablet.vue?vue&type=template&id=c494cc18"
import script from "./Tablet.vue?vue&type=script&lang=js"
export * from "./Tablet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports